module.exports = __webpack_public_path__ + "assets/images/ava-test.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/users-and-access/roles/role-users/images/ava-test.png
// module id = ctaC
// module chunks = 1